import React, { createContext, useContext, useRef, useState } from 'react';
import { Alert } from '@mui/material';

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [alertData, setAlertData] = useState({ message: null, severity: 'success' });

  const timerRef = useRef(null);

  const showAlert = (message, severity = 'success') => {
    clearTimeout(timerRef.current);
    setAlertData({ message, severity });
    timerRef.current = setTimeout(() => setAlertData({ message: null, severity: 'success' }), 5000); // Remove o alerta após 5 segundos
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {alertData.message && (
        <div
            style={{
            position: 'fixed',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            // Acima do navbar (z-index 9999 em NavBar/Styled.jsx) e dos modais do MUI (1300)
            zIndex: 10000,
            }}
        >
          <Alert role="alert" aria-live="polite" variant='filled' severity={alertData.severity} onClose={() => setAlertData({ message: null, severity: 'success' })}>
            {alertData.message}
          </Alert>
        </div>
      )}
    </AlertContext.Provider>
  );
};

export const useAlert = () => useContext(AlertContext);
